module.exports = __webpack_public_path__ + "static/img/accessories01.31aff08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anatomy/accessories01.png
// module id = zkt4
// module chunks = 0